export default "__VITE_ASSET__DwqOShcL__"